import { IPartProTradeBidVehicleDetail } from "../models/partPro/IPartProTradeBids";

export const RS_CORE_LOGO_SRC =
  "https://sawilmasharedstoragepuks.blob.core.windows.net/public/images/logos/rs/rs_core_logo.svg";

export const PARTPRO_TRADE_LOGO_SRC = "https://partpro.co.uk/brand/trade/logo.svg";

export interface IPartLabelSecondLogo {
  src: string;
  alt: string;
}

/**
 * A part is a PartPro Trade part when its vehicle went out for trade bidding and the part's
 * category was awarded to a trade buyer there. Only the award decides it - an open or
 * passed-on category is still the yard's to sell.
 */
export function isPartProTradeAward(
  categoryId: string | null | undefined,
  tradeVehicle: Pick<IPartProTradeBidVehicleDetail, "lots"> | null | undefined
): boolean {
  if (!categoryId || !tradeVehicle) return false;
  const id = categoryId.toLowerCase();
  return tradeVehicle.lots.some((lot) => lot.status === "AWARDED" && lot.partCategoryId?.toLowerCase() === id);
}

/** The logo beside the yard's own on a part label: PartPro Trade wins over RS Core. */
export function partLabelSecondLogo(opts: { isCore: boolean; isPartProTrade: boolean }): IPartLabelSecondLogo | undefined {
  if (opts.isPartProTrade) return { src: PARTPRO_TRADE_LOGO_SRC, alt: "PartPro Trade" };
  if (opts.isCore) return { src: RS_CORE_LOGO_SRC, alt: "RS Core" };
  return undefined;
}
